// import profile from "../../assets/svg/profile.png";
import star from "../../assets/svg/star.svg";
import titlebg from "../../assets/svg/tittle-bg.svg";
import backshine from "../../assets/svg/backshine.svg";
import nextlogoLeft from "../../assets/svg/nextlogo-left.svg";
import nextlogoRight from "../../assets/svg/nextlogo-right.svg";
import borderlayer3 from "../../assets/svg/borderlayer3.svg";
import borderlayer1 from "../../assets/svg/borderlayer1.svg";
import borderlayer4 from "../../assets/svg/borderlayer4.svg";
import borderlayer2 from "../../assets/svg/borderlayer2.svg";
import Thinborder1 from "../../assets/svg/Thinborder1.svg";
import Thinborder2 from "../../assets/svg/Thinborder2.svg";
import Thinborder3 from "../../assets/svg/Thinborder3.svg";
import Thinborder4 from "../../assets/svg/Thinborder4.svg";
import bordercruve1 from "../../assets/svg/bordercruve1.svg";
import bordercruve2 from "../../assets/svg/bordercruve2.svg";
import bordercruve3 from "../../assets/svg/bordercruve3.svg";
import bordercruve4 from "../../assets/svg/bordercruve4.svg";
import PreviewAvatarPlaceholder from "../../assets/images/person-avatar-placeholder.png";
import moment from "moment";
import { useState } from "react";

interface AwardsPreviewProps {
    date?: string;
    recognitionFor?: string[];
    description?: any;
    projects?: any;
    nomineeUser?: any;
}
const AwardsPreview = ({ date, recognitionFor, description, projects, nomineeUser }: AwardsPreviewProps) => {
    const [imgSrc, setImgSrc] = useState(nomineeUser?.personal_image || PreviewAvatarPlaceholder);
    return (
       
        <div className="border-main">
            <img src={nextlogoLeft} alt="" className="nextlogo-left" />
            <div className="card">
                <span className="boder-1">
                    <img src={bordercruve1} alt="" />
                </span>
                <span className="boder-2">
                    <img src={bordercruve2} alt="" />
                </span>
                <div className="thinborder_wrapper">
                    <span className="boder-1">
                        <img src={Thinborder1} alt="" className="Thinborder1_img" />
                    </span>
                    <span className="boder-2">
                        <img src={Thinborder2} alt="" className="Thinborder2_img" />
                    </span>
                    <div className="card_wrapper">
                        <span className="innerboder-1">
                            <img src={borderlayer3} alt="" className="innerborder_topleft" />
                            <img src={borderlayer1} alt="" className="innerborder_topright" />
                        </span>
                        <div className="titlewrap">
                            <div className="title_border ">
                                <img src={titlebg} alt="" className="titleback_img" />
                                <div className="title">
                                    <div><img src={star} alt="" /></div>
                                    <h3 className="text-2xl font-aeonikBold font-bold leading-[normal]">Wall of Fame</h3>
                                    <div><img src={star} alt="" /></div>
                                </div>
                            </div>
                            <p className="text-sm font-aeonikBold font-bold text-center mt-2">{date ? moment(date)?.format("MMMM YYYY") : ''}</p>
                        </div>

                        <div className="grid grid-cols-2 mt-3 items-center award-main-wrap">
                            <div className="awards_wrapper text-center">
                                <p className="Awards_heading text-lg font-aeonikReg">Awarded to</p>
                                <div className="wrapper-certificate-profile">
                                    <img src={backshine} alt="" className="backshine_img" />
                                    <div className="maskwrapper">
                                        <div className="border-certifiacte">
                                            <div className="masked mask2">
                                                {<img src={imgSrc} alt="" width="" height="" onError={() => setImgSrc(PreviewAvatarPlaceholder)} />}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ribbon">
                                        <h2 className="award_winner">{nomineeUser?.name}</h2>
                                        <div className="project_name justify-center flex gap-1 flex-wrap">
                                            {Array.isArray(projects) && projects?.map((item: any, index: number) => {
                                                const isLastItem = index === projects?.length - 1;
                                                return (
                                                    <p key={index}>
                                                        {item?.project?.name}{!isLastItem && " | "}
                                                    </p>
                                                );
                                            })}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="Recognized_wrapper text-center">
                                <p className="Awards_heading text-lg font-aeonikReg text-center mb-3">Recognized for</p>
                                {Array.isArray(recognitionFor) && recognitionFor.map((item: any, index: any) => {
                                    return (
                                        <div key={index} className="Recognized_wrap bg-greenCol rounded-basicRadius flex space-x-2 py-2 px-2 justify-center items-center mb-3 w-max mx-auto">
                                            {/* <div className="icon_wrap_Recognized"><img src={star} alt="" /></div> */}
                                            <h3 className="text-base font-aeonikBold font-bold leading-[normal] text-white">{item?.recognition?.title}</h3>
                                            {/* <div className="icon_wrap_Recognized"><img src={star} alt="" /></div> */}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="w-full mx-auto text-center description_details">
                            <div className="description_details_content">
                                <div className="height-manager">
                                    <p className="text-base m-0 break-words" dangerouslySetInnerHTML={{ __html: description }} />
                                </div>
                            </div>
                        </div>
                        <span className="innerboder-2">
                            <img src={borderlayer4} alt="" className="innerborder_bottomleft" />
                            <img src={borderlayer2} alt="" className="innerborder_bottomright" />
                        </span>
                    </div>
                    <span className="boder-3">
                        <img src={Thinborder3} alt="" className="Thinborder3_img" />
                    </span>
                    <span className="boder-4">
                        <img src={Thinborder4} alt="" className="Thinborder4_img" />
                    </span>
                </div>

                <span className="boder-3">
                    <img src={bordercruve3} alt="" />
                </span>
                <span className="boder-4">
                    <img src={bordercruve4} alt="" />
                </span>
            </div>
            <img src={nextlogoRight} alt="" className="nextlogo-right" />
        </div>

    );
};

export default AwardsPreview;
